/** Google Analytics 4 measurement ID from env (public). */
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

let gtagInitStarted = false;

export function ensureGtagStub(): void {
  window.dataLayer ??= [];
  const dataLayer = window.dataLayer;
  if (window.gtag) return;
  window.gtag = function gtag(this: void) {
    // Mirror Google's stub: queue until gtag.js loads.
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
  };
}

export function loadGtagScript(measurementId: string): void {
  if (gtagInitStarted) return;
  gtagInitStarted = true;
  ensureGtagStub();
  window.gtag!('js', new Date());
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  s.onerror = () => {
    // Content blockers/privacy extensions block gtag.js; queued calls stay in dataLayer.
  };
  document.head.appendChild(s);
}
